import { IStoryFolder, IPublicationFolderWithStories } from '../types';
import { IAccordionListNode } from '@opengov/component-library/capital/AccordionList/AccordionList';

// function to build folder ids based on folder hierachy
export function buildFolderIds(data: any, folderIds: string[] = []): string[] {
  while (data?.length > 0) {
    const currentObj = data.pop();
    const actualFolderList = currentObj.hasOwnProperty('storyFolder') ? currentObj.storyFolder : currentObj;
    folderIds.push(actualFolderList.id);
    Object.keys(actualFolderList).forEach((key) => {
      if (key === 'subFolders' && typeof actualFolderList[key] === 'object' && actualFolderList[key] !== null) {
        actualFolderList[key].forEach((folder) => {
          data.push(folder);
        });
      }
    });
  }
  return folderIds;
}

export const sortListByTitleAndOrder = (folderListWithStories) => {
  return folderListWithStories
    .sort((obj1, obj2) => {
      return obj1.order - obj2.order || obj1.title.localeCompare(obj2.title, undefined, { sensitivity: 'accent' });
    })
    .map((node) => {
      if (node.stories?.length) {
        const stories = sortListByTitleAndOrder(node.stories);
        node.stories = stories;
      }
      if (node.subFolders?.length) {
        const subFolders = sortListByTitleAndOrder(node.subFolders);
        node.subFolders = subFolders;
      }
      return node;
    });
};

export const filterEmptySections = (sections: IStoryFolder[]): IStoryFolder[] =>
  sections.reduce((acc, section) => {
    const filderedSubSections = filterEmptySections(section.subFolders || []);
    if (filderedSubSections.length || section.stories.length) {
      const updatedSection: IStoryFolder = {
        ...section,
        subFolders: filderedSubSections
      };
      return [...acc, updatedSection];
    } else {
      return acc;
    }
  }, []);

const generateAccordionSelectionStructure = (
  section: IPublicationFolderWithStories,
  expandSections: boolean
): IAccordionListNode => {
  const children = [
    ...section.stories.map((story) => ({
      id: story.id,
      displayName: story.title,
      disabled: false,
      toggled: expandSections
    })),
    ...(section.subFolders?.map((subFolder) => generateAccordionSelectionStructure(subFolder, expandSections)) || [])
  ];

  // Return parent sections with subfolders as toggled and disabled.
  return {
    id: `${section.id}__select_option_disabled_styles_clear`,
    displayName: section.title,
    disabled: true,
    toggled: expandSections,
    children
  };
};

// expandSections defaults to true to preserve the SetupPDF stories sidebar's
// existing behavior (all sections pre-expanded for export selection).
export const generateDataStructureForSections = (
  sections: IPublicationFolderWithStories[],
  expandSections = true
): IAccordionListNode[] => sections.map((section) => generateAccordionSelectionStructure(section, expandSections));
